import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = {
    ...Abstrap.propTypes,
    active: PropTypes.bool,
    inner: PropTypes.bool,
    link: PropTypes.bool,
    inline: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    active: false,
    componentClass: 'li',
    inner: false,
    link: false,
    inline: false,
};

class ListItem extends Abstrap {

    getClassNameSchema() {
        const {
            active,
            className,
            inner,
            link,
            inline,
        } = this.props;
        return [
            'c-list__item',
            active ? 'c-list__item--active' : false,
            inner ? 'c-list__item--inner' : false,
            link ? 'c-list__item--link' : false,
            inline ? 'c-list__item--inline' : false,
            className,
        ];
    }

}

ListItem.propTypes = propTypes;

ListItem.defaultProps = defaultProps;

export default ListItem;
